import { render, staticRenderFns } from "./wrap-section.vue?vue&type=template&id=1facadb8"
import script from "./wrap-section.vue?vue&type=script&lang=ts"
export * from "./wrap-section.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports